import { useTranslation } from "react-i18next";
import { Clock3 } from "lucide-react";
import type { AppointmentDetailsController } from "@/components/calendar/useAppointmentDetailsController";

export function AppointmentEventsCard({ ctrl }: { ctrl: AppointmentDetailsController }) {
  const { t } = useTranslation("calendar");
  const { patientDayEvents, handleOpenDayEvent, isOpeningDayEvent } = ctrl;
  return (
    <section className="rounded-[18px] border border-border/30 bg-card p-4 shadow-sm">
      <div className="mb-2.5 text-sm font-bold">{t("appointmentDetails.events")}</div>
      {patientDayEvents.length === 0 ? (
        <div className="rounded-xl border border-dashed border-border/40 p-4 text-center text-[13px] text-muted-foreground">
          {t("appointmentDetails.noEventsToday")}
        </div>
      ) : (
        <ul className="flex flex-col gap-2.5">
          {patientDayEvents.map((ev) => (
            <li key={ev.id}>
              <button
                type="button"
                onClick={() => void handleOpenDayEvent(ev)}
                disabled={isOpeningDayEvent}
                className="flex w-full gap-3 rounded-[14px] border border-border/30 bg-background-app px-3.5 py-3 text-left"
              >
                <span className="w-1 shrink-0 self-stretch rounded-full bg-primary" />
                <span className="min-w-0 flex-1">
                  <span className="flex items-center justify-between gap-2">
                    <span className="truncate text-sm font-bold">{ev.title}</span>
                    <span className="flex shrink-0 items-center gap-1 text-xs tabular-nums text-muted-foreground">
                      <Clock3 className="size-3" />
                      {ev.displayTime}
                    </span>
                  </span>
                  {ev.subtitle ? (
                    <span className="mt-1 block text-[13px] text-muted-foreground">{ev.subtitle}</span>
                  ) : null}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
